export const SET_PAYMENT_DATA = "payment/SET_PAYMENT_DATA";
export const RESET_PAYMENT_DATA = "payment/RESET_PAYMENT_DATA";
export const INITIATE_PAYMENT = "payment/INITIATE_PAYMENT";
export const PROMO_VALIDATION = "payment/PROMO_VALIDATION";

export const UPDATE_AUTO_PAY = "payment/UPDATE_AUTO_PAY";
export const UPDATE_ORDER_LISTING = "payment/UPDATE_ORDER_LISTING";
